import gql from 'graphql-tag';

export const ENTITY_TAGS_QUERY = gql`
  query EntityTags($entityName: String!) {
    entity(name: $entityName) {
      id
      tagCategories {
        id
        name
        tags {
          edges {
            node {
              id
              name
              tagCategoryName
              attributes
            }
          }
        }
      }
    }
  }
`;
